import React from 'react';
import {IconButton, IconButtonProps} from '@mui/material';
import CastIcon from '@mui/icons-material/Cast';
import CastConnectedIcon from '@mui/icons-material/CastConnected';
import {KeePlayingCast} from './index';
import {useCastSelector} from '../../store/slices/cast/castSlice';

interface CastButtonProps {
    size?: number;
    edge?: IconButtonProps['edge'];
    className?: string;
}

/**
 * Reads availability + session state from Redux. Tap toggles between
 * showing the native device picker and ending the session. Hidden when
 * Cast SDK isn't available on this device.
 */
export const CastButton: React.FC<CastButtonProps> = ({size = 22, edge, className}) => {
    const {available, state} = useCastSelector(['available', 'state']);

    if (!available) return null;

    const isConnecting = state === 'starting';
    const isCasting = state === 'started';

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (isCasting) {
            KeePlayingCast.endSession().catch(() => {});
        } else {
            KeePlayingCast.requestSession().catch(() => {
                // User cancelled the picker — no-op.
            });
        }
    };

    return (
        <IconButton
            aria-label={isCasting ? 'Stop casting' : 'Cast to device'}
            onClick={handleClick}
            disabled={isConnecting}
            edge={edge}
            className={className}
        >
            {isCasting
                ? <CastConnectedIcon sx={{fontSize: size, color: '#f4d160'}}/>
                : <CastIcon sx={{fontSize: size, color: 'rgba(255,255,255,0.85)'}}/>}
        </IconButton>
    );
};
